import {IServiceFactory} from '../../service-factory.interface';
import {GameInfo} from '../../games/game-info';

export enum PreviewFeatureType {
  description = 1,
  check = 2
}

export interface PreviewFeatureEvaluationResult {
  title: string;
  value: any;
  type: PreviewFeatureType;
}
export interface IGamePreviewFeature {
  readonly name: string;
  evaluate(services: IServiceFactory, gameInfo: GameInfo): PreviewFeatureEvaluationResult;
}
